import React, { Component, ErrorInfo, ReactNode } from 'react';
import posthog from 'posthog-js';

interface Props {
    children: ReactNode;
    fallback?: ReactNode;
}

interface State {
    hasError: boolean;
}

class ErrorBoundary extends Component<Props, State> {
    state: State = { hasError: false };

    static getDerivedStateFromError(): State {
        return { hasError: true };
    }

    componentDidCatch(error: Error, info: ErrorInfo) {
        console.error('ErrorBoundary caught:', error, info);
        posthog.capture('error_boundary_caught', {
            error_message: error.message,
            component_stack: info.componentStack,
        });
    }

    render() {
        if (this.state.hasError) {
            return (
                this.props.fallback ?? (
                    <div style={{ padding: '40px', textAlign: 'center' }}>
                        <h2>Something went wrong.</h2>
                        <p>Please refresh the page or try again later.</p>
                    </div>
                )
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
